import styled, { css } from 'styled-components';
var ImageContainer = styled.span.attrs(function (_ref) {
  var imageWidth = _ref.imageWidth,
      imageHeight = _ref.imageHeight,
      viewportHeight = _ref.viewportHeight;
  return {
    style: {
      height: viewportHeight,
      maxHeight: imageHeight || 'none',
      maxWidth: imageWidth
    }
  };
}).withConfig({
  displayName: "ImageContainer",
  componentId: "sc-63jikd-0"
})(["display:block;transition:height 0.5s ease-in-out;", ";"], function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile && css(["box-shadow:inset 0px 10px 10px -10px rgba(0,0,0,0.4);"]);
});
export default ImageContainer;